// index.js - Modified to remove StrictMode which can cause issues with animations
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './components/theme.css';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode> - Removing StrictMode as it causes double renders
    <App />
  // </React.StrictMode>
);